import { Navigate, useLocation } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "@/components/common/EmptyState";

export const ShellSkeleton = () => (
  <div className="flex min-h-screen bg-background" data-testid="shell-skeleton" aria-busy="true">
    <div className="hidden w-64 shrink-0 sidebar md:block" />
    <div className="flex-1 p-8 space-y-6">
      <Skeleton className="h-10 w-1/3 rounded-xl" />
      <Skeleton className="h-5 w-1/2 rounded-xl" />
      <div className="grid gap-4 md:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-40 rounded-xl" />
        ))}
      </div>
    </div>
  </div>
);

export function RequireAuth({ children, allowOnboarding = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <ShellSkeleton />;
  if (user === false) return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  if (!user.onboarded && !allowOnboarding) return <Navigate to="/welcome" replace />;
  return children;
}

export function RequireOwner({ children }) {
  const { user } = useAuth();
  if (user?.role !== "owner") {
    return (
      <EmptyState
        icon={ShieldOff}
        title="This area is for Owners"
        body="Your role does not include admin access. Ask an Owner if you need something changed."
        testid="no-access"
      />
    );
  }
  return children;
}

export function PublicOnly({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user) return <Navigate to={location.state?.from || "/"} replace />;
  return children;
}
